import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Autocomplete from '@mui/material/Autocomplete';
import { TreeView } from '@mui/x-tree-view/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { FormControlLabel, Paper } from '@mui/material';
import data from './data.json';
import { getToken } from '../../utils/common';
import logger from '../../utils/logger';

const capitalizeFirst = (str) => {
  const str1 = str.split('_').join(' ');
  return str1.charAt(0).toUpperCase() + str1.slice(1);
};
const bfsSearch = (graph, targetId) => {
  const queue = [...graph];

  while (queue.length > 0) {
    const currNode = queue.shift();
    if (currNode.id === targetId) {
      return currNode;
    }
    if (currNode.children) {
      queue.push(...currNode.children);
    }
  }
  return [];
};

// Helper functions moved to outer scope for better performance
function getAllIds(node, idList = []) {
  idList.push(node.id);
  if (node.children) {
    node.children.forEach((child) => getAllIds(child, idList));
  }
  return idList;
}

export default function Pekerja(props) {
  const history = useNavigate();

  const [username, setusername] = React.useState('');
  const [email, setemail] = React.useState('');
  const [namalengkap, setnamalengkap] = React.useState('');
  const [nomorponsel, setnomorponsel] = React.useState('');
  const [unitkerja, setunitkerja] = React.useState('');
  const [role, setrole] = React.useState('');
  const [aktif, setaktif] = React.useState('Active');
  const [level, setlevel] = React.useState('Maker');
  const [checked, setChecked] = React.useState([true, false]);

  const [selectedNodes, setSelectedNodes] = React.useState([]);
  React.useEffect(() => {}, [selectedNodes]);

  const getAllChild = (id) => getAllIds(bfsSearch(data, id));

  const getAllFathers = (id, list = []) => {
    const node = bfsSearch(data, id);
    if (node.parent) {
      list.push(node.parent);

      return getAllFathers(node.parent, list);
    }

    return list;
  };

  function isAllChildrenChecked(node, list) {
    const allChild = getAllChild(node.id);
    const nodeIdIndex = allChild.indexOf(node.id);
    allChild.splice(nodeIdIndex, 1);

    return allChild.every((nodeId) => selectedNodes.concat(list).includes(nodeId));
  }

  const handleNodeSelect = (event, nodeId) => {
    event.stopPropagation();
    const allChild = getAllChild(nodeId);
    const fathers = getAllFathers(nodeId);

    if (selectedNodes.includes(nodeId)) {
      setSelectedNodes((prevSelectedNodes) => prevSelectedNodes.filter((id) => !allChild.concat(fathers).includes(id)));
    } else {
      const ToBeChecked = allChild;

      setSelectedNodes((prevSelectedNodes) => [...prevSelectedNodes].concat(ToBeChecked));
    }
  };

  const handleExpandClick = (event) => {
    event.stopPropagation();
  };

  const renderTree = (nodes) => (
    <Grid item xs={6}>
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        onClick={handleExpandClick}
        label={
          <>
            <Checkbox
              checked={selectedNodes.indexOf(nodes.id) !== -1}
              tabIndex={-1}
              disableRipple
              onClick={(event) => handleNodeSelect(event, nodes.id)}
            />
            {nodes.name}
          </>
        }
      >
        {Array.isArray(nodes.children) ? nodes.children.map((node, _i) => renderTree(node)) : null}
      </TreeItem>
    </Grid>
  );

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  const children = (
    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
      <FormControlLabel label="Child 1" control={<Checkbox checked={checked[0]} onChange={handleChange2} />} />
      <FormControlLabel label="Child 2" control={<Checkbox checked={checked[1]} onChange={handleChange3} />} />
    </Box>
  );

  const postData = async () => {
    const payload = [];

    let payloadd;
    data.map((c, i) => {
      let create = false;
      let read = false;
      let update = false;
      let deleted = false;
      if (selectedNodes.find((e) => e === c.id && c.id === '1')) {
        create = true;
        read = true;
        update = true;
        deleted = true;
      }
      if (selectedNodes.find((e) => e === c.id && c.id === '99')) {
        create = true;
        read = true;
        update = true;
        deleted = true;
      }
      if (c.children !== undefined) {
        c.children.map((ca, ii) => {
          if (selectedNodes.find((e) => e === ca.id)) {
            switch (ca.name) {
              case 'Create':
                create = true;
                break;
              case 'Read':
                read = true;
                break;
              case 'Update':
                update = true;
                break;
              case 'Delete':
                deleted = true;
                break;
              default:
            }
          }
          payloadd = {
            nama_menu: c.name,
            create,
            update,
            delete: deleted,
            read,
          };
          return ca;
        });
      } else {
        payloadd = {
          nama_menu: c.name,
          create,
          update,
          delete: deleted,
          read,
        };
      }
      payload.push({
        nama_menu: c.name,
        create,
        update,
        delete: deleted,
        read,
      });
      return c;
    });
    const item = {
      email,
      menu_access: payload,
      username,
      nama_lengkap: namalengkap,
      phone: nomorponsel,
      work_unit: unitkerja,
      role,
      is_active: aktif === 'Active',
      level,
    };

    try {
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });

      const data = await response.json();
      alert(data.error_message || data.message);
    } catch (error) {
      logger.error('Error:', error);
    }
    history('/dashboard/user');
  };
  React.useEffect(() => {}, []);

  const TextfieldCustom2 = ({
    id = '',
    size = '',
    tittle = '',
    placeholder = '',
    dropdown = [],
    label = '',
    multiline = false,
    value = '',
    changer,
  }) => (
    <Grid item md={size}>
      <Grid container direction={'column'} spacing={0}>
        <Grid item>
          <Typography variant="subtitle2">{tittle}</Typography>
        </Grid>
        <Grid item>
          {dropdown != '' ? (
            <Autocomplete
              fullWidth
              size="small"
              key={id}
              disablePortal
              value={(dropdown || []).find((e) => e[label] === value)}
              id={id}
              onChange={(event, newValue) => {
                changer(newValue[label]);
              }}
              options={dropdown}
              getOptionLabel={(dropdown) => (dropdown && dropdown[label]) || ''}
              getOptionSelected={(option, selectedValue) => option[label] === selectedValue[label]}
              renderInput={(params) => (
                <TextField
                  key={id}
                  // onBlur={formik.handleBlur}
                  // error={formik.touched[id] && Boolean(formik.errors[id])}
                  // helperText={formik.touched[id] && formik.errors[id]}
                  {...params}
                  fullWidth
                  placeholder={capitalizeFirst(id)}
                />
              )}
            />
          ) : (
            <TextField
              fullWidth
              id={id}
              multiline={multiline}
              name={id}
              size="small"
              placeholder={placeholder}
              //   label={capitalizeFirst(id)}
              value={value}
              onChange={(e) => {
                changer(e.target.value);
              }}
              // error={formik.touched[id] && Boolean(formik.errors[id])}
              // helperText={formik.touched[id] && formik.errors[id]}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <span>
      {/* <pre style={{ textAlign: "left" }}>{JSON.stringify(formik, null, 2)}</pre> */}
      {/* style={{ padding: 20, height: "80vh" }} */}
      <Paper
        style={{
          padding: 20,
          minHeight: '80vh',
          backgroundColor: '#fafafc',
          boxShadow: 'none',
        }}
      >
        <Grid container direction={'row'} spacing={2}>
          {TextfieldCustom2({
            id: 'username',
            size: 6,
            tittle: 'Username',
            dropdown: '',
            placeholder: 'Username',
            value: username,
            changer: setusername,
          })}
          {TextfieldCustom2({
            id: 'email',
            size: 6,
            tittle: 'Email',
            dropdown: '',
            placeholder: 'Email@gmail.com',
            value: email,
            changer: setemail,
          })}
          {TextfieldCustom2({
            id: 'namalengkap',
            size: 6,
            dropdown: '',
            tittle: 'Full Name',
            placeholder: 'Full Name',
            value: namalengkap,
            changer: setnamalengkap,
          })}
          {TextfieldCustom2({
            id: 'nomorponsel',
            size: 6,
            dropdown: '',
            tittle: 'Phone Number',
            placeholder: '08122323',
            value: nomorponsel,
            changer: setnomorponsel,
          })}
          {TextfieldCustom2({
            id: 'unitkerja',
            size: 6,
            tittle: 'Work Unit',
            dropdown: '',
            placeholder: 'Management',
            value: unitkerja,
            changer: setunitkerja,
          })}
          {TextfieldCustom2({
            id: 'role',
            size: 6,
            tittle: 'Role',
            dropdown: '',
            placeholder: 'Supervisor',
            value: role,
            changer: setrole,
          })}
          {}
          <Grid item xs={12}>
            <Typography>Menu Access</Typography>
          </Grid>
          <Grid item xs={12}>
            <TreeView
              multiSelect
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
              selected={selectedNodes}
            >
              <Grid container direction={'row'} xs={12}>
                {data?.map((node) => renderTree(node))}
              </Grid>
            </TreeView>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Status</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={aktif}
                onChange={(e) => setaktif(e.target.value)}
              >
                <FormControlLabel value="Active" control={<Radio />} label="Active" />
                <FormControlLabel value="inActive" control={<Radio />} label="inActive" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label">Level Access</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={level}
                onChange={(e) => setlevel(e.target.value)}
              >
                <FormControlLabel value="Maker" control={<Radio />} label="Maker" />
                <FormControlLabel value="Approval" control={<Radio />} label="Approver" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} style={{ textAlignLast: 'right' }}>
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              style={{
                textTransform: 'none',
                backgroundColor: '#679DA0',
              }}
              onClick={postData}
            >
              Create User
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </span>
  );
}

Pekerja.propTypes = {
  // PropTypes removed as they are not used
};
